const STAR_COLOUR = '#F9AC14'

export interface Props {
  value: number
  theme?: 'dark' | 'clear'
  expanded?: boolean
  starSize?: number
}

const StarRatingBadge = ({ value, theme = 'dark', expanded = false, starSize = 10 }: Props): JSX.Element | null => {
  return null
  // if (expanded) {
  //   const filledCount = Math.floor(value)
  //   return (
  //     <Brick theme={theme}>
  //       <Text className="pr-xxs" size="xxs" weight="md">
  //         {value}
  //       </Text>
  //       {Array(filledCount)
  //         .fill(0)
  //         .map((_, i) => (
  //           <Icon key={`filled-star-${i}`} align="middle" color={STAR_COLOUR} size={starSize} name="star-filled" />
  //         ))}
  //       {Array(5 - filledCount)
  //         .fill(0)
  //         .map((_, i) => (
  //           <Icon key={`outlined-star-${i}`} align="middle" color={STAR_COLOUR} size={starSize} name="star-outline" />
  //         ))}
  //     </Brick>
  //   )
  // }
  // return (
  //   <Brick theme={theme}>
  //     <Icon color={STAR_COLOUR} size={starSize} name="star-filled" />
  //     {value}
  //   </Brick>
  // )
}
export default StarRatingBadge
